import {
  generateAttachmentUploadUrl as publicGenerateAttachmentUploadUrl,
  listAttachments as publicListAttachments,
  deleteAttachment as publicDeleteAttachment,
  getAttachment as publicGetAttachment,
} from './contacts-v4-attachment-attachments.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { onAttachmentCreated as publicOnAttachmentCreated } from './contacts-v4-attachment-attachments.public.js';
import { onAttachmentDeleted as publicOnAttachmentDeleted } from './contacts-v4-attachment-attachments.public.js';

export const generateAttachmentUploadUrl: MaybeContext<
  BuildRESTFunction<typeof publicGenerateAttachmentUploadUrl> &
    typeof publicGenerateAttachmentUploadUrl
> = /*#__PURE__*/ createRESTModule(publicGenerateAttachmentUploadUrl);
export const listAttachments: MaybeContext<
  BuildRESTFunction<typeof publicListAttachments> & typeof publicListAttachments
> = /*#__PURE__*/ createRESTModule(publicListAttachments);
export const deleteAttachment: MaybeContext<
  BuildRESTFunction<typeof publicDeleteAttachment> &
    typeof publicDeleteAttachment
> = /*#__PURE__*/ createRESTModule(publicDeleteAttachment);
export const getAttachment: MaybeContext<
  BuildRESTFunction<typeof publicGetAttachment> & typeof publicGetAttachment
> = /*#__PURE__*/ createRESTModule(publicGetAttachment);
/** */
export const onAttachmentCreated: BuildEventDefinition<
  typeof publicOnAttachmentCreated
> &
  typeof publicOnAttachmentCreated = createEventModule(
  publicOnAttachmentCreated
);
/** */
export const onAttachmentDeleted: BuildEventDefinition<
  typeof publicOnAttachmentDeleted
> &
  typeof publicOnAttachmentDeleted = createEventModule(
  publicOnAttachmentDeleted
);

export {
  AttachmentType,
  CrmAttachmentAttachmentType,
  DemoContactType,
  WebhookIdentityType,
} from './contacts-v4-attachment-attachments.universal.js';
export {
  ContactAttachment,
  ContactAttachmentMediaOneOf,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  Empty,
  CrmAttachmentUploadedEvent,
  CrmAttachment,
  AttachmentSource,
  AttachmentMetadata,
  AttachmentMedia,
  AttachmentMediaMediaOneOf,
  CreateDemoAttachmentRequest,
  CreateDemoAttachmentResponse,
  GenerateAttachmentUploadUrlRequest,
  GenerateAttachmentUploadUrlResponse,
  ListAttachmentsRequest,
  Paging,
  ListAttachmentsResponse,
  PagingMetadata,
  DeleteAttachmentRequest,
  DeleteAttachmentResponse,
  GetAttachmentRequest,
  GetAttachmentResponse,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  AttachmentCreatedEnvelope,
  AttachmentDeletedEnvelope,
  GenerateAttachmentUploadUrlOptions,
  ListAttachmentsOptions,
  DeleteAttachmentIdentifiers,
  GetAttachmentIdentifiers,
} from './contacts-v4-attachment-attachments.universal.js';
export {
  AttachmentTypeWithLiterals,
  CrmAttachmentAttachmentTypeWithLiterals,
  DemoContactTypeWithLiterals,
  WebhookIdentityTypeWithLiterals,
} from './contacts-v4-attachment-attachments.universal.js';
